import { useApp } from '../../../../contexts/AppContext';

interface DetectSearchCurrentLocation {
  storeCurrentLocation: string | null;
  checkLocationChange: (newLocation: string) => boolean;
}

export const useDetectSearchCurrentLocation = (): DetectSearchCurrentLocation => {
  const { storeCurrentLocation, setStoreCurrentLocation } = useApp();

  const checkLocationChange = newLocation => {
    if (newLocation !== storeCurrentLocation) {
      setStoreCurrentLocation(newLocation);
      return true;
    }
    return false;
  };

  return { storeCurrentLocation, checkLocationChange };
};
